
import React, {Component} from 'react';
import {Button} from 'react-bootstrap'
import EmployeeQRCodeModal from './EmployeeQRCodeModal'
import FontAwesome from 'react-fontawesome'
class EmployeeQRCodeButton extends Component {

  constructor(...args){
    super(...args)
    this.state = {show:false}
  }

  onClick(){
    this.setState({show:true})
  }

  render(){
    let {show} = this.state
    return (
      <div>
        <Button  onClick={this.onClick.bind(this)}>
          <FontAwesome name='qrcode'/>{' '} QRCode          
        </Button>
        <EmployeeQRCodeModal
        {...this.props} 
        show={show}                 
        onHide={()=>{this.setState({show:false})}}/>
      </div>
    )
  }
}

export default EmployeeQRCodeButton;





// WEBPACK FOOTER //
// ./src/view/hr/EmployeeQRCodeButton.js